import css from './productList.module.scss'
import { useContext } from 'react'
import { AuthContext } from '../../context/auth'
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from 'react-router-dom';

export const ProductList = ({
    products,
    setSelectedProduct,
    fetchMoreData = () => { },
    hasMore = false,
    maxHeight,
    createSlug = false,
    fetchProductWithSlug,
    isLoading
}) => {
    const navigate = useNavigate()
    const { width } = useContext(AuthContext)

    return (
        products?.length > 0 ?
            <div className={css.list} style={{ maxHeight, height: maxHeight }}>
                <InfiniteScroll
                    dataLength={products.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                >
                    {width > 750 ?
                        <table className={css.mainTable}>
                            <thead>
                                <tr>
                                    <th>Product Name</th>
                                    <th>Cat ID#</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products?.map((product) => {
                                    return (
                                        <tr
                                            key={product?.id}
                                            onClick={() => {
                                                if (createSlug) {
                                                    navigate(`/v1/product-search/${product?.product_handle}`)
                                                } else {
                                                    setSelectedProduct(product)
                                                }
                                            }}
                                        >
                                            <td>
                                                {product?.title ? product?.title : "-"}
                                            </td>
                                            <td>
                                                {product?.material ? product?.mid_code + " " + product?.material : "-"}
                                            </td>
                                            <td><span>{product?.variants ? `$${(product?.variants[0]?.prices[0]?.amount / 100)?.toFixed(2)}` : product?.price ? `$${(product?.price / 100)?.toFixed(2)}` : "-"}</span></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        :
                        <div className={css.col}>
                            {products?.map((product, index) => {
                                return <div key={index} className={`${css.col} ${css.productCard}`} onClick={() => setSelectedProduct(product)}>
                                    <h4>{product.title ? product?.title : '-'}</h4>
                                    <div className={css.row}>
                                        <h5>{product?.material ? product?.mid_code + " " + product?.material : "-"}</h5>
                                        <h4>{product?.variant ? `$${(product?.variants[0]?.prices[0]?.amount / 100)?.toFixed(2)}` : product?.price ? `$${(product?.price / 100)?.toFixed(2)}` : "-"}</h4>
                                    </div>
                                </div>
                            })}
                        </div>
                    }
                </InfiniteScroll>
            </div>
            : !isLoading &&
            (
                <div className={css.noProduct}>
                    <span className={css.icon}>
                        <i className="fal fa-boxes"></i>
                    </span>
                    <p>No Products Available Yet.</p>
                </div>
            )
    )
}